<template>  
    <v-dialog
        v-model="dialog"
        max-width="900px"
    >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="primary"
            large
            v-bind="attrs"
            v-on="on"
        >
            Créer un nouveau contrôle périodique
        </v-btn>
        </template>
        <v-card>
        <v-card-title>
            <span v-if="dataToModify == null" class="text-h5">Création d'un contrôle périodique</span>
            <span v-else class="text-h5">Modification d'un contrôle périodique</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false" >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-form ref="formAddCheck" v-model="isAddCheckFormValid">
            <v-container>
                <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                <template>
                <v-select
                    v-model="lifts_selected"
                    :items="lift_list"
                    item-text='lift_name'
                    item-value='lift_id'
                    label="Remontée(s)"
                    multiple
                    :rules="[v => (v && v.length > 0) || 'Sélectionner au moins une remontée']"
                >
                    <template v-slot:prepend-item>
                    <v-list-item
                        ripple
                        @mousedown.prevent
                        @click="toggle_lift"
                    >
                        <v-list-item-content>
                        <v-list-item-title>
                            Tout sélectionner
                        </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                    </template>
                </v-select>
                </template>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                    v-model="category_selected"
                    :items="categoryOptions"
                    label="Catégorie"
                    :rules="[v => !!v || 'Requis']"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                    v-model="check_name"
                    label="Nom du contrôle"
                    :rules="[v => !!v || 'Requis']"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-select
                        v-model="interval_days"
                        :items="intervalOptions"
                        item-text="label"
                        item-value="value"
                        label="Fréquence"
                        :rules="[v => !!v || 'Requis']"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                        v-model="description"
                        label="Description"
                        rows="3"
                        outlined
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
            >
            Annuler
            </v-btn>
            <v-btn
            color="blue darken-1"
            text
            @click="saveCheck"
            :disabled="!isAddCheckFormValid"
            >
            Enregistrer
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogCreatePeriodicCheck",
    props: {
        dataToModify: {
            type: Object,
            default: null,
        }
    },
    data(){
        return {
            dialog: false,
            isAddCheckFormValid: false,
            lifts_selected: [],
            category_selected: null,
            check_name: '',
            interval_days: null,
            description: '',
            categoryOptions: [
                'Véhicules',
                'Ligne',
                'Moteur'
            ],
            intervalOptions: [
                { label: 'Hebdomadaire (7 jours)', value: 7 },
                { label: 'Bi-mensuel (15 jours)', value: 15 },
                { label: 'Mensuel (30 jours)', value: 30 },
                { label: 'Trimestriel (90 jours)', value: 90 },
                { label: 'Semestriel (180 jours)', value: 180 },
                { label: 'Annuel (365 jours)', value: 365 },
            ],
        }
    },
    computed: {
        lift_list(){
            return this.$store.state.liftsStore.liftsList
        },
        all_lifts_selected () {
            return this.lifts_selected.length === this.lift_list.length
        },
    },
    watch: {
        dataToModify: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.lifts_selected = newValue.lifts_id_selected || []
                    this.category_selected = newValue.check_category
                    this.check_name = newValue.check_name
                    this.interval_days = newValue.interval_days
                    this.description = newValue.description || ''
                    this.dialog = true
                } else {
                    this.resetForm()
                }
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('closeCreation')
                this.resetForm()
            }
        }
    },
    methods: {
        toggle_lift () {
            this.$nextTick(() => {
                if (this.all_lifts_selected) {
                this.lifts_selected = []
                } else {
                this.lifts_selected = this.lift_list.map(x => x.lift_id)
                }
            })
        },
        async saveCheck() {
            if (this.$refs.formAddCheck.validate()) {
                try {
                    await this.$store.dispatch('addPeriodicCheck', {
                        check_id: this.dataToModify?.check_id || null,
                        lifts_selected: this.lifts_selected,
                        check_name: this.check_name,
                        check_category: this.category_selected,
                        interval_days: this.interval_days,
                        description: this.description,
                    })
                    this.dialog = false
                    this.$store.dispatch('addNotification', {
                        message: 'Contrôle enregistré avec succès',
                        type: 'success'
                    })
                } catch (error) {
                    this.$store.dispatch('addNotification', {
                        message: 'Erreur lors de l\'enregistrement',
                        type: 'error'
                    })
                }
            }
        },
        resetForm() {
            this.lifts_selected = []
            this.category_selected = null
            this.check_name = ''
            this.interval_days = null
            this.description = ''
            if (this.$refs.formAddCheck) {
                this.$refs.formAddCheck.resetValidation()
            }
        }
    }
}
</script>
